var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashbackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_15088_106491)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15088_106491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3206 9.39406L17.5487 10.3857C19.2125 11.6803 20.0425 13.7764 19.7149 15.8564C19.475 17.3826 18.6548 18.7241 17.4059 19.6339C16.1564 20.5432 14.6281 20.9128 13.1018 20.6716C9.95112 20.1755 7.79077 17.2086 8.28604 14.0577C8.526 12.5312 9.34636 11.1897 10.5955 10.2801C11.6861 9.48621 12.9894 9.10489 14.3184 9.18053L13.2321 10.3201L14.038 11.0891L15.7527 9.28895L15.7531 9.28961L16.5213 8.48296L15.716 7.71478L15.7156 7.71503L13.9161 6L13.1473 6.80665L14.3199 7.92344C12.726 7.84806 11.1648 8.3117 9.85608 9.26459C8.33567 10.3716 7.33737 12.0044 7.04506 13.8626C6.44212 17.6977 9.07139 21.3094 12.9065 21.9129C13.2771 21.9713 13.6476 22 14.0158 22C15.493 22 16.9283 21.5357 18.1453 20.6494C19.6659 19.5422 20.664 17.9094 20.9563 16.0516C21.355 13.5205 20.345 10.9693 18.3206 9.39406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6899 18.5487V18.5484L14.69 17.8254C15.5474 17.7297 16.3815 17.1881 16.3815 16.1599C16.3815 14.7628 15.0825 14.6026 14.1336 14.4858C13.527 14.4133 13.0627 14.3291 13.0627 13.9616C13.0627 13.4507 13.7829 13.3956 14.0926 13.3956C14.5523 13.3956 15.0428 13.6117 15.2094 13.8875L15.2578 13.9676L16.2108 13.5266L16.1637 13.4305C15.8085 12.7044 15.1721 12.4944 14.6898 12.4096V11.7729H13.5738V12.4069C12.5349 12.5601 11.9179 13.1367 11.9179 13.9616C11.9179 15.3067 13.1392 15.4432 14.0303 15.5431C14.8244 15.6368 15.194 15.833 15.194 16.1599C15.194 16.7844 14.3292 16.8332 14.064 16.8332C13.4739 16.8332 12.9049 16.5387 12.7403 16.1477L12.6994 16.0512L11.6641 16.4902L11.7053 16.5867C12.0119 17.3043 12.6735 17.754 13.574 17.8604V18.5487H14.6899Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15088_106491",
    x1: 34.2332,
    y1: 21.7668,
    x2: 21.7668,
    y2: -6.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3920A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15088_106491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackIcon);
export default __webpack_public_path__ + "static/media/Cashback_Icon.7db2ee98d3b148f5dc6f1aa112a2de65.svg";
export { ForwardRef as ReactComponent };